// extracted by mini-css-extract-plugin
export default {"container":"pL-z","topReviewHeading":"qL-z","criticalReview":"rL-z","favorableReview":"sL-z","vsSeparator":"tL-z"};